enum DOCUMENT_VISIBILITY {
  None = 0,
  PrimarySeller = 1,
  PrimaryBuyer = 2,
  SecondarySeller = 4,
  SecondaryBuyer = 8,
}

export default DOCUMENT_VISIBILITY;
